import { useState } from "react";
import { Modal, Input, Button } from "@marekl/adminer/components";
import { useChangePassword } from "../../auth/queries";
import { notifySuccess, notifyError } from "@marekl/adminer/api";

interface Props {
  open: boolean;
  onClose: () => void;
}

export function ChangePasswordModal({ open, onClose }: Props) {
  const changePassword = useChangePassword();
  const [form, setForm] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });
  const [errors, setErrors] = useState<Partial<typeof form>>({});

  function reset() {
    setForm({ current_password: "", new_password: "", confirm_password: "" });
    setErrors({});
  }

  function close() {
    if (changePassword.isPending) return;
    reset();
    onClose();
  }

  function validate() {
    const e: Partial<typeof form> = {};
    if (!form.current_password) e.current_password = "Povinné pole";
    if (form.new_password.length < 8) e.new_password = "Nové heslo musí mít alespoň 8 znaků";
    if (form.new_password !== form.confirm_password) e.confirm_password = "Hesla se neshodují";
    setErrors(e);
    return Object.keys(e).length === 0;
  }

  async function handleSubmit(ev: React.FormEvent) {
    ev.preventDefault();
    if (!validate()) return;
    try {
      await changePassword.mutateAsync({
        current_password: form.current_password,
        new_password: form.new_password,
      });
      notifySuccess("Heslo bylo úspěšně změněno.");
      reset();
      onClose();
    } catch (err) {
      notifyError(err);
    }
  }

  return (
    <Modal
      open={open}
      title="Změnit heslo"
      onClose={close}
      footer={
        <>
          <Button onClick={close}>Zrušit</Button>
          <Button
            variant="primary"
            loading={changePassword.isPending}
            onClick={handleSubmit as unknown as React.MouseEventHandler}
          >
            Uložit
          </Button>
        </>
      }
    >
      <form
        onSubmit={handleSubmit}
        noValidate
        style={{ display: "flex", flexDirection: "column", gap: 14 }}
      >
        <Input
          id="profile-current-password"
          label="Aktuální heslo *"
          type="password"
          value={form.current_password}
          onChange={(e) => setForm((f) => ({ ...f, current_password: e.target.value }))}
          error={errors.current_password}
          autoComplete="current-password"
        />
        <Input
          id="profile-new-password"
          label="Nové heslo *"
          type="password"
          value={form.new_password}
          onChange={(e) => setForm((f) => ({ ...f, new_password: e.target.value }))}
          error={errors.new_password}
          autoComplete="new-password"
          hint="Minimálně 8 znaků"
        />
        <Input
          id="profile-confirm-password"
          label="Potvrdit nové heslo *"
          type="password"
          value={form.confirm_password}
          onChange={(e) => setForm((f) => ({ ...f, confirm_password: e.target.value }))}
          error={errors.confirm_password}
          autoComplete="new-password"
        />
      </form>
    </Modal>
  );
}
